import React from 'react';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_pusha-rebrand/artifacts/utn0sdo9_PUSHA_TEE_GLOW_LOGO.png';

export function Logo({ className = '' }) {
  return (
    <div className={`flex items-center select-none ${className}`}>
      <img
        src={LOGO_URL}
        alt="Pusha Teez"
        className="h-12 md:h-14 w-auto drop-shadow-[0_0_14px_rgba(57,255,20,0.45)]"
        loading="eager"
      />
    </div>
  );
}

export function BigNeonLogo({ compact = false }) {
  return (
    <div className={`flex items-center justify-center ${compact ? 'py-2 md:py-3' : 'py-10 md:py-16'}`}>
      <img
        src={LOGO_URL}
        alt="Pusha Teez"
        className={`${compact ? 'w-[180px] md:w-[230px] lg:w-[250px]' : 'w-[280px] md:w-[440px] lg:w-[560px]'} h-auto drop-shadow-[0_0_35px_rgba(57,255,20,0.55)]`}
        loading="eager"
      />
    </div>
  );
}
